<p-sidebar styleClass="sidebar-menu" [(visible)]="sidebarMenuVisible" [fullScreen]="true">
  <div class="col-md-6 offset-md-3 mt-5" (click)="toggleNavbarCollapsing()">
    <img style="margin: auto" src="assets/icons/company_logo.png" />
    <!-- <h3>Menu</h3> -->
    <div *ngIf="isLoggedIn">
      {{ partnerName }}&nbsp;
      <i style="cursor: pointer" (click)="changeAccountClicked($event)" class="pi pi-folder"></i>
    </div>
    <div *ngIf="isLoggedIn">
      {{ userName }}&nbsp;
      <span
        style="cursor: pointer; color: red"
        (click)="logoutClicked($event)"
        id="logout"
        pTooltip="Logout"
        tooltipPosition="bottom"
      >
        <i class="pi pi-power-off"></i>
      </span>
    </div>
    <hr />
    <div *ngIf="isLoggedIn">
      <a routerLink="/account-info" routerLinkActive="menu-active">Account information</a>
      <a routerLink="/customers" routerLinkActive="menu-active">Customers</a>
      <a routerLink="/invoices" routerLinkActive="menu-active">Invoices</a>
      <div class="admin-menu" *ngIf="isLsAdmin">
        <hr />
        <a routerLink="/ehf-replication" routerLinkActive="menu-active">NAV ehf replication</a>
        <a routerLink="/admin-users" routerLinkActive="menu-active">Users</a>
      </div>
    </div>
  </div>
</p-sidebar>
<app-header></app-header>
<app-navbar></app-navbar>
<div [className]="isLoggedIn ? 'd-flex main-container' : 'd-flex main-container-public'">
  <app-sidebar></app-sidebar>
  <div class="container-fluid mt-3 mb-5">
    <div class="container container-90">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>

<footer class="footer">
  <div class="row justify-content-between">
    <div class="col-md-2 col-xs-12 col-sm-12 text-center">
      <div class="mx-5">
        <img src="assets/icons/company_logo.png" alt="LS Retail logo" style="width: 180px" />
      </div>
    </div>
    <div class="col-md-4 col-xs-12 col-sm-12 text-center">
      <a class="p-2" target="_blank" href="https://www.lsretail.com">LS Retail Website</a>
      <a *ngIf="!isDirEndUser" class="p-2" style="margin: 0 5px" target="_blank" href="https://portal.lsretail.com/"
        >LS Retail Portal</a
      >
      <a class="p-2" target="_blank" href="https://portal.lsretail.com/privacy-policy/"
        >Privacy Policy &amp; Terms of Use</a
      >
    </div>
    <div class="col-md-3 col-xs-12 col-sm-12 text-center">
      <span>Copyright © {{ currentYear }} LS Retail ehf. All rights reserved. </span>
      <!-- <span>BC V.{{version}}</span> -->
    </div>
  </div>
</footer>
<p-toast position="bottom-center"></p-toast>
